import React from "react";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  Container,
  InputLabel,
  FormControl,
} from "@mui/material";
import {
  Group,
  Bungalow,
  Functions,
  Accessible,
  LocalParking,
  KeyboardArrowDownOutlined,
} from "@mui/icons-material";

import HeadingText from "./HeadingText";

function Parking({ register, watch, setValue, errors }) {
  return (
    <Container maxWidth={"md"}>
      <Grid container>
        <Grid item xs={12} sm={5}>
          <HeadingText
            main="Parking Information"
            sub="Input all the required information to continue."
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box sx={{ position: "relative", marginBottom: "48px" }}>
            <LocalParking
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Number of Parking Spots <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="number"
              placeholder="Number of Parking Spots"
              style={{ marginTop: 20 }}
              {...register("pSpot", { required: "Number of Parking Spots is required" })}
            />
            {errors.pSpot && <p className="error">{errors.pSpot.message}</p>}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "48px" }}>
            <LocalParking
              sx={{
                position: "absolute",
                top: "25px",
                left: "12px",
                backgroundColor: "#186fe7",
                color: "#fff",
                borderRadius: "3px",
                scale: "0.8",
              }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Number of Tenant Parking <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="number"
              placeholder="Number of Tenant Parking"
              style={{ marginTop: 20 }}
              {...register("pNumber", { required: "Number of Tenant Parking is required" })}
            />
            {errors.pNumber && (
              <p className="error">{errors.pNumber.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "48px" }}>
            <Group
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Number of Guest Parking <span style={{ color: "red" }}>*</span>
            </label>
            <input
              className="text_input"
              type="number"
              placeholder="Number of Guest Parking"
              style={{ marginTop: 20 }}
              {...register("pNumGuest", { required: "Number of Guest Parking is required" })}
            />
            {errors.pNumGuest && (
              <p className="error">{errors.pNumGuest.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "48px" }}>
            <Bungalow
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Number of Administration Parking
            </label>
            <input
              className="text_input"
              type="number"
              placeholder="Number of Administration Parking"
              style={{ marginTop: 20 }}
              {...register("pAdmin", { required: "Number of Administration Parking is required" })}
            />
            {errors.pAdmin && (
              <p className="error">{errors.pAdmin.message}</p>
            )}
          </Box>

          <Box sx={{ position: "relative", marginBottom: "48px" }}>
            <Accessible
              color="primary"
              sx={{ position: "absolute", top: "25px", left: "12px" }}
            />
            <label style={{ position: "absolute", left: 10, top: 0, color: "#186FE7", fontSize: 14 }}>
              Number of Handicap Parking
            </label>
            <input
              className="text_input"
              type="number"
              placeholder="Number of Handicap Parking"
              style={{ marginTop: 20 }}
              {...register("pHandcap", { required: "Number of Handicap Parking is required" })}
            />
            {errors.pHandcap && (
              <p className="error">{errors.pHandcap.message}</p>
            )}
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={5}>
          <HeadingText
            main="System of Labeling Parking Spots"
            sub="Set a range or specific system to label each parking spot at the complex lot."
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Box sx={{ marginBottom: "48px" }}>
            <FormControl fullWidth size="small" focused>
              <InputLabel id="parking-system-label" sx={{ left: -5, top: -10, }}>
                Parking System
              </InputLabel>
              <Select
                labelId="parking-system-label"
                id="parking-system"
                {...register("pSystem", { required: "Parking System is required" })}
                value={watch("pSystem") || ""}
                onChange={(e) => setValue("pSystem", e.target.value)}
                color="primary"
                IconComponent={KeyboardArrowDownOutlined}
                autoFocus
                sx={{
                  color: "#186FE7",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                }}
                startAdornment={<Functions color="primary" />}
              >
                <MenuItem disabled value={""}>
                  A - Z
                </MenuItem>
                <MenuItem value="A Complex">A Complex</MenuItem>
                <MenuItem value="Z Complex">Z Complex</MenuItem>
              </Select>
            </FormControl>
            {errors.pSystem && (
              <p className="error">{errors.pSystem.message}</p>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Parking;
